export default __webpack_public_path__ + "scripts/resources/assignments/en/hotcoldpack/reactions.json";